module.exports = __webpack_public_path__ + "img/BridgeChop.3bc28807.png";